import { ReactNode, useState } from 'react';
import { CSSObject } from '@emotion/styled';
import { SubMenu, MenuItem as UIMenuItem } from 'react-pro-sidebar';
import { Stack, IconButton } from '@mui/material';

import AppIcon, { iconTypes } from '@/components/shared/AppIcon/AppIcon';

export type IMenuItem = {
  id: string;
  label: string;
  icon?: ReactNode;
  rootStyles?: CSSObject;
  subMenu?: IMenuItem[];
  iconName?: string;
  isVisible?: boolean;
  resetSelectedUnit?: boolean;
  onClick?: () => void;
};

export type MenuItemProps = {
  item: IMenuItem;
  activePath: string[];
  onChangeActivePath: (key: string[]) => void;
};

export function MenuItem({
  item,
  activePath,
  onChangeActivePath,
}: MenuItemProps) {
  const [open, setOpen] = useState(false);

  // Helper to resolve icon
  const iconContent = item.icon || (item.iconName ? <AppIcon name={item.iconName as any} /> : undefined);

  const toggleOpen = () => {
    setOpen(!open);
  };

  const handleClickSubMenu = () => {
    onChangeActivePath([item.id]);

    if (item.onClick) {
      item.onClick();
    }
  };

  const handleClickMenuItem = () => {
    onChangeActivePath([item.id]);

    if (item.onClick) {
      item.onClick();
    }
  };

  const handleChangeActivePath = (path: string[]) => {
    if (path.length === 0) {
      onChangeActivePath([]);
    } else {
      onChangeActivePath([item.id, ...path]);
    }
  };

  const active =
    activePath.length > 0
      ? activePath[activePath.length - 1] === item.id
      : false;
  const newActivePath = activePath;

  if (item.subMenu) {
    return (
      <Stack direction="row" alignItems="flex-start">
        <SubMenu
          label={item.label}
          icon={iconContent}
          rootStyles={item.rootStyles}
          active={active}
          open={open}
          onOpenChange={(isOpen) => setOpen(isOpen)}
        >
          {item.subMenu.map((sub) => (
            <MenuItem
              key={sub.id}
              item={sub}
              activePath={newActivePath}
              onChangeActivePath={handleChangeActivePath}
            />
          ))}
        </SubMenu>
      </Stack>
    );
  }

  return (
    <UIMenuItem
      onClick={handleClickMenuItem}
      key={item.id}
      icon={iconContent}
      rootStyles={item.rootStyles}
      active={active}
    >
      {item.label}
    </UIMenuItem>
  );
}
